import { ComponentProps, FC, Children } from 'react';
import { Flex } from 'portal-commons';

const ROW_WIDTHS = ['calc(50% - 18px)', 'calc(50% - 18px)'];
const COLUMN_GAP = '36px';
const Horizontal: FC<ComponentProps<typeof Flex> & { widths?: string[] }> = ({
  children,
  sx,
  widths = ROW_WIDTHS,
  ...restProps
}) => (
  <Flex sx={{ flexDirection: 'row', gap: COLUMN_GAP, ...sx }} {...restProps}>
    {Children.map(children, (child, index) => (
      <Flex sx={{ flex: widths[index] ? `0 0 ${widths[index]}` : 1 }}>
        {child}
      </Flex>
    ))}
  </Flex>
);

const Vertical: FC<ComponentProps<typeof Flex>> = ({
  children,
  sx,
  ...restProps
}) => (
  <Flex
    sx={{ flexDirection: 'column', gap: 's', flex: 1, ...sx }}
    {...restProps}
  >
    {children}
  </Flex>
);

export const InfoItemLayout = {
  Horizontal,
  Vertical,
};

export default InfoItemLayout;
